import Vue from 'vue';

Vue.component('brand-history-navigation-component', {
    data() {
        return {
            allNavItems: [],
            navigationList: null,
            timeout: null,
            showArrows: false,

            // Set values of first nav items so it's active by default.
            activeLink: '#1924',
            activeText: '1924',

            isPrevDisabled: false,
            isNextDisabled: false,
            isMobile: false,
        };
    },

    mounted() {
        this.allNavItems = this.initPageNav(
            document.querySelectorAll('[data-navigation-item]'),
        );
        this.navigationList = document.querySelector(
            '.brand-history__navigation-list',
        );
        this.timeout = setTimeout(() => {
            this.handleElementHorizontalOverflow();
        }, 10);
        this.addIdOfElementToUrlOnScroll();
    },

    watch: {
        activeLink(newLink) {
            this.handleScrollToNavElement(newLink);
            this.handleDisableButtonScroll();
        },
        navigationList(list) {
            if (!list) return;
            list.addEventListener('scroll', this.handleDisableButtonScroll);
        },
    },

    created() {
        window.addEventListener('resize', this.handleElementHorizontalOverflow);
        window.addEventListener('scroll', this.addIdOfElementToUrlOnScroll);
    },

    destroyed() {
        window.removeEventListener(
            'resize',
            this.handleElementHorizontalOverflow,
        );
        window.removeEventListener('scroll', this.addIdOfElementToUrlOnScroll);

        if (!this.navigationList) return;
        this.navigationList.removeEventListener(
            'scroll',
            this.handleDisableButtonScroll,
        );

        if (!this.timeout) return;
        clearTimeout(this.timeout);
    },

    methods: {
        parseBrandHistoryNavigationText(text) {
            if (!text?.includes('-')) return text;
            return text.split('-').join(' - ');
        },

        handleDisableButtonScroll() {
            if (!this.navigationList) return;

            this.isPrevDisabled = this.navigationList.scrollLeft === 0;
            this.isNextDisabled =
                Math.abs(this.navigationList.scrollLeft) ===
                this.navigationList.scrollWidth -
                    this.navigationList.clientWidth;
        },

        handleSetActiveText(item) {
            if (
                !item.dataset.navigationText ||
                this.activeText === item.dataset.navigationText
            )
                return;

            this.activeText = item.dataset.navigationText;
        },

        addIdOfElementToUrlOnScroll() {
            const navItems = document.querySelectorAll(
                '[data-navigation-item]',
            );

            for (const item of navItems) {
                if (!item.dataset.navigationItem) continue;

                const element = document.getElementById(
                    item.dataset.navigationItem,
                );
                const elementTop = element.getBoundingClientRect().top - 100;
                const elementBottom =
                    element.getBoundingClientRect().bottom - 100;
                const isElementOnTop =
                    elementTop <= 1 &&
                    elementBottom > 0 &&
                    elementTop < elementBottom;

                if (isElementOnTop) {
                    const newLink = `#${item.dataset.navigationItem}`;
                    this.activeLink = newLink;
                    history.replaceState(undefined, undefined, newLink);
                    this.handleSetActiveText(item);

                    // Break out of the loop once the first in-view item is found
                    break;
                }
            }
        },

        handleElementHorizontalOverflow() {
            this.isMobile = window.innerWidth < 768;

            const element = document.querySelector(
                '.brand-history__navigation-list',
            );

            if (element.scrollWidth > element.clientWidth) {
                this.showArrows = true;
                return;
            }

            this.showArrows = false;
        },

        initPageNav(allNavigationItems) {
            if (!allNavigationItems) return;

            const allItems = [];

            for (const item of allNavigationItems) {
                if (!item.dataset.navigationText) continue;
                allItems.push({
                    navigateTo: `#${item.dataset.navigationItem}`,
                    text: item.dataset.navigationText,
                    imageSrcWebp: this.parseImageUrl(
                        item.dataset.navigationImageWebp,
                    ),
                    imageSrcJpeg: this.parseImageUrl(
                        item.dataset.navigationImageJpeg,
                    ),
                    id: `brand-history-nav-${item.dataset.navigationItem}`,
                });
            }

            return allItems;
        },

        parseImageUrl(imageUrl) {
            return imageUrl.replace('&transform_width=', ' ');
        },

        toggleScrollNext() {
            this.getScrollByValue();
            if (!this.navigationList) return;
            this.navigationList.scrollBy({
                left: this.getScrollByValue(),
                behavior: 'smooth',
            });
        },

        toggleScrollPrev() {
            if (!this.navigationList) return;
            this.navigationList.scrollBy({
                left: -this.getScrollByValue(),
                behavior: 'smooth',
            });
        },

        getScrollByValue() {
            if (!this.isMobile) return 164;

            const element = document.querySelector(
                `#${this.allNavItems[0].id}`,
            );

            return element.clientWidth;
        },

        handleUrlChange() {
            window.addEventListener('hashchange', (e) => {
                this.activeLink = e.newURL;
            });
        },

        handleScrollToNavElement(activeItem) {
            const activeElement = document.querySelector(
                `#brand-history-nav-${activeItem.split('#')[1]}`,
            );

            if (!activeElement) return;

            if (this.isMobile) {
                this.navigationList.scrollLeft = activeElement.offsetLeft - 90;
                return;
            }

            this.navigationList.scrollLeft = activeElement.offsetLeft - 170;
        },

        isItemActive(link) {
            // This always needs to have two numbers
            const arrayOfNumbers = this.activeText.includes('-')
                ? this.activeText.split('-').map((item) => parseInt(item))
                : [parseInt(this.activeText), parseInt(this.activeText)];
            const parsedLink = parseInt(link.split('#')[1]);

            const isParsedLinkInRange =
                parsedLink === arrayOfNumbers[0] ||
                (parsedLink >= arrayOfNumbers[0] &&
                    parsedLink <=
                        arrayOfNumbers[arrayOfNumbers.length - 1] - 1);

            return isParsedLinkInRange
                ? 'brand-history__navigation-list__item--active'
                : '';
        },
    },
});
